export enum ActivityType {
  SpecialistOfqualSendPublicMessage = 7000,
  SpecialistCitizenSendPublicMessage = 7001,
  SpecialistPublicMessageRead = 7002,
  SpecialistCreateNote = 7003,
  SpecialistInternalMessage = 7004,
  SpecialistSmsChange = 7005,
  SpecialistFurtherEvidenceRequested = 7006,
  SpecialistAddExpertise = 7007

}
